var Slider_3_columns = {
	init:function(){

		$(window).resize(function(){
			Slider_3_columns.resize();	
		});

		Slider_3_columns.resize();


	},
	resize:function(){

		var _carousel = $("[slider-3-columns] .slick-container");

		if (_carousel.hasClass('slick-initialized')) {
			_carousel.slick('unslick');
		}

		//var _slides_to_show = parseInt($("[slider-3-columns]").css("padding-top"));

		var _slides_to_show = 1;
		var els = document.querySelectorAll("[slider-3-columns]");

		Array.prototype.forEach.call(els, function(el) {
			//Debug.log("SLIDES TO SHOW : " + el + " => " + parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide")));
			
			_slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));
			
		});

		

		_carousel.slick({
			arrows:true, 
			dots:true,
			infinite: false,
			variableWidth:true,
			slidesToShow: _slides_to_show,
			focusOnSelect: true,
			touchThreshold:500,
			prevArrow:_carousel.parent().find(".arrow.prev"),
			nextArrow:_carousel.parent().find(".arrow.next"),
		});	
	}
}

$(window).load(function(){
	if($("[slider-3-columns]").length){
		Slider_3_columns.init();
	}
})